import { ShoesState } from 'src/types'
import { pointSole } from './pointSole'
import { resinSoleEvaWhiteCleats } from './resinSoleEvaWhiteCleats'
import { leatherSoleWithEva } from './leatherSoleWithEva'
import { runningShoesSole } from './runningShoesSole'
import { artificialTurfSole } from './artificialTurfSole'

export const outSoles = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  const outSole = state.outSole.value
  if (outSole === 'pointSole') {
    pointSole(ctx, state)
    return
  }

  if (['resinSoleEvaWhiteCleats', 'unselected'].includes(outSole)) {
    resinSoleEvaWhiteCleats(ctx, state)
    return
  }

  if (['leatherSoleWithEva'].includes(outSole)) {
    leatherSoleWithEva(ctx, state)
    return
  }

  // ランニングシューズソール
  if (['runningShoesSole'].includes(outSole)) {
    runningShoesSole(ctx, state)
    return
  }

  if (['artificialTurfSole'].includes(outSole)) {
    // 人工芝ソール
    artificialTurfSole(ctx, state)
    return
  }
}
